import { ICourseStructureCategoryTreeQuery } from '../interfaces/course-structure-category-tree.query.interface';
import { CourseStructureCategoryBreadcrumb } from './course-structure-category-breadcrumb.model';

// @dynamic
export class CourseStructureCategoryTree {
    category: {
        id: string;
        name: string;
        type: string;
        sort: number;
        offeringCount: number;
    };
    numberOfResults: number;
    breadcrumbs: CourseStructureCategoryBreadcrumb[];
    breadcrumbLabel: string;
    children?: CourseStructureCategoryTree[];

    constructor(courseStructureCategoryTreeQuery: ICourseStructureCategoryTreeQuery) {
        if (courseStructureCategoryTreeQuery) {
            this.category = {
                id: courseStructureCategoryTreeQuery.category.id,
                name: courseStructureCategoryTreeQuery.category.name,
                sort: courseStructureCategoryTreeQuery.category.sort,
                type: courseStructureCategoryTreeQuery.category.type,
                offeringCount: courseStructureCategoryTreeQuery.category.offering_count,
            };
            this.numberOfResults = courseStructureCategoryTreeQuery.number_of_results ? courseStructureCategoryTreeQuery.number_of_results : null;
            this.breadcrumbs = courseStructureCategoryTreeQuery.breadcrumbs
                ? courseStructureCategoryTreeQuery.breadcrumbs.map((breadcrumb) => new CourseStructureCategoryBreadcrumb(breadcrumb))
                : [];
            this.breadcrumbLabel = this.breadcrumbs.map((breadcrumb) => breadcrumb.name).join(' / ');
            this.children = courseStructureCategoryTreeQuery.children
                ? courseStructureCategoryTreeQuery.children.map((courseStructureCategoryTree) => new CourseStructureCategoryTree(courseStructureCategoryTree))
                : [];
        }
    }
}
